import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { mesasService } from '../../services/api';
import { useToast } from '../../components/ui/Toast';
import { segmentos, segmento } from '../../components/ui/estilos';
import Reservas from './Reservas';
import Eventos from './Eventos';

export default function Agenda() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('t') === 'eventos' ? 'eventos' : 'reservas';
  const [mesas, setMesas] = useState<any[]>([]);
  const [toast, say] = useToast();
  useEffect(() => { mesasService.getAll().then(r => setMesas(r.data)).catch(() => say('No se pudieron cargar las mesas.')); }, [say]);

  return (
    <div style={{ margin: '-22px -24px', height: 'calc(100% + 44px)', minHeight: 480, display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 'none', display: 'flex', alignItems: 'center', gap: 16, padding: '12px 20px', background: 'var(--surface)', borderBottom: '1px solid var(--line)' }}>
        <Link to="/comandera" style={{ fontSize: 14, fontWeight: 700, color: 'var(--muted)', textDecoration: 'none' }}>← Salón</Link>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Agenda</h1>
        <div role="tablist" style={segmentos}>
          {([['reservas', 'Reservas'], ['eventos', 'Eventos']] as const).map(([k, l]) => (
            <button key={k} role="tab" aria-selected={tab === k} onClick={() => setParams(k === 'eventos' ? { t: 'eventos' } : {})} style={{ ...segmento(tab === k), height: 40, fontSize: 15 }}>{l}</button>
          ))}
        </div>
      </div>
      {tab === 'reservas' ? <Reservas mesas={mesas} say={say} /> : <Eventos mesas={mesas} say={say} />}
      {toast}
    </div>
  );
}
